import React from 'react';
import ReactEmojiPicker, {
    EmojiStyle,
    Categories,
} from "emoji-picker-react";
import { useSelector } from 'react-redux';
import { getTheme } from '@icarius-pages/login/selectors';
import { Popover } from '@material-ui/core';
import { getLocalizedString } from '@icarius-localization/strings';


const EmojiPicker = (props) => {

    const {
        anchorEl,
        handleChange,
        handleClose,
    } = props;

    const { theme } = useSelector(getTheme);

    const DEFAULT_CATEGORIES = [
        {
            name: getLocalizedString("emojisAndPeople"),
            category: Categories.SMILEYS_PEOPLE,
        },
        {
            name: getLocalizedString("animalsAndNature"),
            category: Categories.ANIMALS_NATURE,
        },
        {
            name: getLocalizedString("foodAndDrinks"),
            category: Categories.FOOD_DRINK,
        },
        {
            name: getLocalizedString("activities"),
            category: Categories.ACTIVITIES,
        },
        {
            name: getLocalizedString("travelAndPlaces"),
            category: Categories.TRAVEL_PLACES,
        },
        {
            name: getLocalizedString("objects"),
            category: Categories.OBJECTS,
        },
        {
            name: getLocalizedString("symbols"),
            category: Categories.SYMBOLS,
        },
    ];

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            onClose={handleClose}
        >
            <ReactEmojiPicker
                onEmojiClick={(e) => {
                    handleChange(e.emoji);
                    handleClose();
                }}
                height={350}
                width={350}
                categories={DEFAULT_CATEGORIES}
                theme={theme}
                autoFocusSearch
                previewConfig={{ showPreview: false }}
                searchPlaceHolder={getLocalizedString("findEmoji")}
                emojiStyle={EmojiStyle.NATIVE}
                emojiVersion="11.0"
            />
        </Popover>
    );
}

export default EmojiPicker;